import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

// PDF paths served from public/docs/trustcall/
const HELP_DOCS: Record<string, { title: string; path: string }> = {
  "user-guide": {
    title: "User Guide",
    path: "/docs/trustcall/TrustCall%20Portal%20User%20Guide%20v04162024.pdf",
  },
};

// Sections that moved to external Mintlify docs
const EXTERNAL_REDIRECTS: Record<string, string> = {
  "api-docs": "https://docs.dncscrub.com/api-reference/trustcall/overview",
};

interface HelpDocViewerProps {
  docKey: string;
}

const HelpDocViewer: React.FC<HelpDocViewerProps> = ({ docKey }) => {
  // Redirect sections that now live on Mintlify
  const externalUrl = EXTERNAL_REDIRECTS[docKey];

  useEffect(() => {
    if (externalUrl) {
      window.location.replace(externalUrl);
    }
  }, [externalUrl]);

  if (externalUrl) {
    return null;
  }

  const doc = HELP_DOCS[docKey];

  if (!doc) {
    return <Navigate to="/trustcall/help/user-guide" replace />;
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <object
        data={doc.path}
        type="application/pdf"
        style={{ width: "100%", height: "calc(100vh - 140px)" }}
      >
        <p>
          Your browser does not support PDFs. Please download the PDF to view it:{" "}
          <a href={doc.path}>Download PDF</a>.
        </p>
      </object>
    </div>
  );
};

export default HelpDocViewer;
